import React from "react";

const AlertModal = ({
  isOpen,
  title = "Alert",
  message = "",
  onClose,
  actions = [],
}) => {
  if (!isOpen) {
    return null;
  }

  const handleAction = (action) => {
    if (typeof action.onClick === "function") {
      action.onClick();
    }
    if (!action.keepOpen && typeof onClose === "function") {
      onClose();
    }
  };

  return (
      <div className="ReactModalPortal">
        <div className="ReactModal__Overlay ReactModal__Overlay--after-open modal-overlay">
          <div
            className="ReactModal__Content ReactModal__Content--after-open modal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-title">
            <h5>{title}</h5>
            <button
              className="btn minus"
              data-colors="primary"
              onClick={onClose}
            >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--carbon"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L26 7.414L24.586 6L16 14.586L7.414 6L6 7.414L14.586 16L6 24.586L7.414 26L16 17.414L24.586 26L26 24.586z"
                  ></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </button>
            </div>
            <div className="modal-content">
            <div className="separator-container">
                <hr className="separator-line" />
              </div>
            <div
              className="unlock-title"
              style={{ justifyContent: "center", textAlign: "center" }}
            >
              <span>{message}</span>
            </div>
          </div>
          {actions.length > 0 && (
            <div className="modal-actions" style={{ marginTop: "1rem" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                {actions.map((action, index) => (
                  <button
                    key={`${action.label}-${index}`}
                    className="btn"
                    data-colors={action.colors || "primary"}
                    onClick={() => handleAction(action)}
                  >
                    <span className="btn-txt">{action.label}</span>
                    <div
                      className="corner"
                      data-colors={action.colors || "primary"}
                    >
                      <span className="corner-left"></span>
                      <span className="corner-right"></span>
                      <span className="corner-top-bottom"></span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
            <div className="corner" data-colors="tertiary">
              <span className="corner-left"></span>
              <span className="corner-right"></span>
              <span className="corner-top-bottom"></span>
            </div>
          </div>
        </div>
      </div>
  );
};

export default AlertModal;
